import { defaultFormFieldTypes, defaultAdditionalFieldTypes } from './fields-classes-floating.js';

let formFieldTypes = [...defaultFormFieldTypes];
let additionalFieldTypes = [...defaultAdditionalFieldTypes];

// Function to merge field configurations
const mergeFieldTypes = (defaultTypes, overrideTypes) => {
  if (!overrideTypes) return defaultTypes;

  const merged = [...defaultTypes];

  overrideTypes.forEach(overrideType => {
    const existingIndex = merged.findIndex(type => type.value === overrideType.value);

    if (existingIndex >= 0) {
      merged[existingIndex] = {
        ...merged[existingIndex],
        ...overrideType,
        classes: {
          ...merged[existingIndex].classes,
          ...overrideType.classes
        }
      };
    } else {
      merged.push(overrideType);
    }
  });

  return merged;
};

// Function to load and merge override fields - direct config objects only
export const loadFieldOverrides = (overrideConfig) => {
  if (!overrideConfig) {
    formFieldTypes = [...defaultFormFieldTypes];
    additionalFieldTypes = [...defaultAdditionalFieldTypes];
    return;
  }

  try {
    // Merge form field types
    if (overrideConfig.formFieldTypes) {
      formFieldTypes = mergeFieldTypes(defaultFormFieldTypes, overrideConfig.formFieldTypes);
    }

    // Merge additional field types
    if (overrideConfig.additionalFieldTypes) {
      additionalFieldTypes = mergeFieldTypes(defaultAdditionalFieldTypes, overrideConfig.additionalFieldTypes);
    }

    console.log('Field overrides loaded successfully');
  } catch (error) {
    console.error('Error loading field overrides:', error);
    formFieldTypes = [...defaultFormFieldTypes];
    additionalFieldTypes = [...defaultAdditionalFieldTypes];
  }
};

// Export current field configurations as getter functions
export const getFormFieldTypes = () => formFieldTypes;
export const getAdditionalFieldTypes = () => additionalFieldTypes;

// Keep the old exports for backward compatibility, but make them reactive
export { formFieldTypes, additionalFieldTypes };
